var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.524865L8.69 0.5M0.5 9.56546L8.69 9.5406",
    stroke: "#90DF9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92382 0.527344H1.26614L1.30707 1.27796C1.36 2.24324 1.77665 3.15262 2.47314 3.82303L3.11653 4.44207C3.19605 4.51845 3.25932 4.61011 3.30254 4.71154C3.34576 4.81298 3.36803 4.9221 3.36803 5.03236C3.36803 5.14262 3.34576 5.25174 3.30254 5.35318C3.25932 5.45461 3.19605 5.54627 3.11653 5.62265L2.47314 6.24118C1.77665 6.91158 1.36 7.82097 1.30707 8.78624L1.26562 9.53634H7.92382L7.88289 8.78779C7.82979 7.82143 7.41215 6.91117 6.71423 6.24066L6.07084 5.62213C5.99124 5.54575 5.9279 5.45406 5.88464 5.35257C5.84137 5.25109 5.81907 5.14191 5.81907 5.03158C5.81907 4.92126 5.84137 4.81208 5.88464 4.71059C5.9279 4.60911 5.99124 4.51742 6.07084 4.44103L6.71423 3.82303C7.41227 3.15239 7.82992 2.24192 7.88289 1.27537L7.92382 0.527344Z",
    stroke: "#90DF9E",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.151965521a66bdb4426c44a244fc7e60.svg";
export { ForwardRef as ReactComponent };